/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1AccountState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_ACCOUNT_STATE_ENTITY_NAME = 'ixc.registration.v1.Account';
export const ixcRegistrationV1AccountStateEntity = new schema.Entity<IxcRegistrationV1AccountState>(IXC_REGISTRATION_V1_ACCOUNT_STATE_ENTITY_NAME, {}, { idAttribute: 'accountId' });

